import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppURL } from 'src/app/app.url';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-secret-key-detail',
  templateUrl: './secret-key-detail.component.html',
  styleUrls: ['./secret-key-detail.component.scss']
})
export class SecretKeyDetailComponent {
  constructor(private http: HttpClient,
    private alert: AlertService,
    private router: Router
  ) {
    this.getRealmList();
  }

  realmItems: any = []
  getRealmList() {
    this.http.get(`realm`).subscribe({
      next: (res: any) => {
        this.realmItems = res.data
      }
    })
  }

  resetItem() {
    this.RealmName = ""
    this.visible = false
    this.viewOtpKey = false
    this.otpClient = ""
    this.otpClientSecret = ""
    this.realmViewItems = ""
  }

  visible: boolean = false;
  setNewRealm() {
    this.visible = true
  }

  RealmName: string = ""
  addRealm() {
    let model = {
      RealmName: this.RealmName
    }
    this.http.post(`realm`, model).subscribe({
      next: (res: any) => {
        this.getRealmList()
        this.resetItem()
        this.alert.notify(res.message, 'success')

      }
    })
  }




  viewKey: boolean = false;
  memberItems: any = []
  realmViewItems: any;
  viewRealm(item: any) {
    this.realmViewItems = item
    this.getSecretItems(item)
  }


  getSecretItems(item: any) {
    this.http.get(`secretkey/${this.realmViewItems.RealmId}`).subscribe({
      next: (res: any) => {
        this.memberItems = res.data
        this.viewKey = true
      }
    })
  }

  addSecretkey() {
    this.http.post(`secretkey/${this.realmViewItems.RealmId}`, null).subscribe({
      next: (res: any) => {
        this.getSecretItems(this.realmViewItems.RealmId)
        this.alert.notify(res.message, 'success')
      }
    })
  }

  resetSecretkey(item: any) {
    this.alert.confirm('การเปลี่ยน Key อาจมีผลกับระบบที่ใช้อยู่').then(f => {
      if (f.isConfirmed) this.http.put(`secretkey/${this.realmViewItems.RealmId}/${item.MemberId}`, null).subscribe({
        next: (res: any) => {
          this.getSecretItems(this.realmViewItems.RealmId)
          this.alert.notify(res.message, 'success')
        }
      })
    })

  }

  viewOtpKey: boolean = false;
  otpClient: string = ""
  otpClientSecret: string = ""
  setOtpKey(item: any) {
    this.viewOtpKey = true
    this.otpClient = item.OtpClientId
    this.otpClientSecret = item.OtpClientSecret
    this.realmViewItems = item;
  }

  saveOtpKey() {
    let model = {
      OtpClientId: this.otpClient,
      OtpClientSecret: this.otpClientSecret
    }
    this.http.put(`otp/${this.realmViewItems.RealmId}`, model).subscribe({
      next: (res: any) => {
        this.getRealmList();
        this.resetItem();
        this.alert.notify(res.message, 'success')
      },
      error: (err) => {
        this.alert.notify(err.error.message, 'warning')
      }
    })
  }

  bankSystem() {
    this.router.navigate(['/', AppURL.secretkey])
  }

}
